module.exports = __webpack_public_path__ + "img/badge-list-thumb-027.5d66ae34.png";